// React
import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, NavLink } from 'react-router-dom';
// Locales
import translate from 'locales/i18n';
// Stores
import LoggedUserStore from 'stores/LoggedUserStore';
// Material components
import { withStyles } from '@mui/styles';
import IconButton from '@mui/material/IconButton';
import Icon from '@mui/material/Icon';

class NotFound extends React.PureComponent {

    static propTypes = {
        classes: PropTypes.object
    };

    render() {
        const { classes } = this.props;

        if (!LoggedUserStore.isLogged()) {
            return (
                <Redirect to='/login' />
            );
        }

        return (
            <div className={classes.root}>
                <div className={classes.textColumnCenter}>
                    <div className={classes.textRowCenter}>
                        <div className={classes.displayText}>
                            <span className={classes.text404}>
                                404
                            </span>
                            <span className={classes.sentence}>
                                {translate.i18n('PAGE_NOT_FOUND')}
                            </span>
                        </div>
                        <div className={classes.displayHomeButton}>
                            <NavLink
                                to={'/dashboard'}
                                activeClassName='active'
                                className={classes.navLink}>
                                <IconButton
                                    title={translate.i18n('HOME')}>
                                    <Icon>home</Icon>
                                </IconButton>
                            </NavLink>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const styles = (theme) => ({
    root: {
        display: 'flex',
        width: '100%',
        height: '80vh',
    },
    textColumnCenter: {
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    textRowCenter: {
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
    },
    displayText: {
        display: 'flex',
        width: '100%',
        flexDirection: 'row',
        justifyContent: 'center',
    },
    displayHomeButton: {
        display: 'flex',
        width: '100%',
        flexDirection: 'row',
        justifyContent: 'center',
    },
    text404: {
        display: 'inline-block',
        borderRight: '1px solid rgba(0, 0, 0, .3)',
        margin: 0,
        marginRight: 20,
        padding: '10px 23px 10px 0',
        fontSize: 24,
        fontWeight: 500,
    },
    sentence: {
        fontSize: 14,
        fontWeight: 'normal',
        lineHeight: 'inherit',
        margin: 0,
        padding: '15px 23px 10px 0',
    },
    navLink: {
        color: theme.palette.black.main,
        textDecoration: 'none',
        '&:focus': {
            textDecoration: 'none',
        },
        '&:hover': {
            textDecoration: 'none',
            color: theme.palette.grey.dark,
        },
        '&:visited': {
            textDecoration: 'none'
        },
        '&:link': {
            textDecoration: 'none'
        },
        '&:active': {
            textDecoration: 'none'
        }
    }
});

export default withStyles(styles)(NotFound);
